import type { LResponse } from '@shared'
import type { Warning } from '../'

export function useWarnings() {
  return useQuery(['ehr', 'notifications', 'warnings'], () => fetchEHR<LResponse<Warning[]>>('/notifications/warnings'), {
    refetchOnWindowFocus: (query) => query.state.errorUpdateCount === 0,
  })
}
